<template>
    <b-modal id="pdf-modal" ref="modal" v-model="localShouldOpenPdfViewerModal" centered  body-class="p-0" size="lg" hide-footer class="pdf-viewer-modal" @hide="close">
        <div v-if="isFetching" class="text-center m-4" style="padding:130px">
            <b-spinner style="width: 2.5rem; height: 2.5rem;" variant="primary" label="Text Centered"></b-spinner>
        </div>

        <div v-else class="bg-transparent-dark">
            <div v-for="page in numOfPages" :key="page">
                <div style="background-color: rgba(79,79,79,.2);">
                    <vue-pdf-embed
                        ref="pdfRef"
                        :page="page"
                        :source="pdfSrc"
                        class="mb-2"
                        @rendered="handleDocumentRender"
                    />
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import {
    BModal,
    BSpinner,
} from 'bootstrap-vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import Document from '@/models/Document';

export default {
    components: {
        VuePdfEmbed,
        BModal,
        BSpinner
    },

    props: {
        activeDocumentId: {
            type: [String, Number],
            required: true,
        },
        shouldOpenPdfViewerModal: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            pdfSrc:'',
            numOfPages: 10,
            isFetching: false,

            loadedRatio: 0,
      	    curPageNum: 0,
            localShouldOpenPdfViewerModal: this.shouldOpenPdfViewerModal
        };
    },

    async created() {
        this. isFetching = true;
        if (this.activeDocumentId)
        {
            const response = await Document.getPdfDocument(this.activeDocumentId);

            const blob = new Blob([response]);
            const objectUrl = URL.createObjectURL(blob);
            this.pdfSrc = objectUrl;
            this.isFetching = false;
        }
    },


    methods: {
        close()
        {
            setTimeout(() => {
                this.$emit('close');
            }, 500);
        },

        handleDocumentRender() {
            this.numOfPages = this.$refs.pdfRef[0].pageCount;
        }
    }

};
</script>
<style>
.page, .canvasWrapper, canvas {
    width: 800px !important;
}

.bg-transparent-dark,
.modal-backdrop
{
    background-color: rgba(0,0,0,.85);
    opacity: 1;
}

</style>